import { AsyncPipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  inject,
  OnDestroy,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FlowLinesService } from '@app/features/app-publishing/services/flow-lines.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { PlatformPublishing } from '../../models/publishing.model';
import { PublishingState } from '../../states/publishing.state';
import { AndroidScreenshotComponent } from '../android-screenshot/android-screenshot.component';
import { PlatformPublishingShellComponent } from '../platform-publishing-shell/platform-publishing-shell.component';
import { PublishingStepComponent } from '../publishing-step/publishing-step.component';

@Component({
  selector: 'rk-android-publishing-card',
  imports: [
    PlatformPublishingShellComponent,
    FontAwesomeModule,
    PublishingStepComponent,
    AsyncPipe,
    AndroidScreenshotComponent,
  ],
  templateUrl: './android-publishing-card.component.html',
  styleUrl: './android-publishing-card.component.scss',
})
export class AndroidPublishingCardComponent implements AfterViewInit, OnDestroy {
  @ViewChildren(PublishingStepComponent)
  stepComponents!: QueryList<PublishingStepComponent>;

  androidPublishingData$: Observable<PlatformPublishing> = inject(Store).select(
    PublishingState.androidPublishingData,
  );
  androidScreenshot$: Observable<string> = inject(Store).select(
    PublishingState.androidScreenshot,
  );
  playStoreLink$: Observable<string> = inject(Store).select(
    PublishingState.playStoreLink,
  );

  private readonly subscription = new Subscription();
  private readonly flowLinesService = inject(FlowLinesService);

  ngAfterViewInit() {
    this.flowLinesService.updateFlowLines(this.stepComponents);

    this.subscription.add(
      this.stepComponents.changes.subscribe(() => {
        setTimeout(() => this.flowLinesService.updateFlowLines(this.stepComponents), 100);
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
